import InputWrapper from '@designSystem/InputWrapper';
import React from 'react';
import { Control, Controller, RegisterOptions } from 'react-hook-form';
import ReactSelect from 'react-select';

import { customSelectStyles } from '../../../../style/customSelectStyle';
import { VerticalityFormInputs } from '../../types';

interface VerticalitySelectProps {
  options: { value: string; label: string }[];
  selectdValue: string | undefined;
  registerTitle: 'building' | 'stair' | 'floor' | 'outlet';
  label: string;
  placeholder: string;
  control: Control<VerticalityFormInputs>;
  rules: RegisterOptions;
}

const VerticalitySelect: React.FC<VerticalitySelectProps> = ({
  control,
  options,
  selectdValue,
  registerTitle,
  label,
  placeholder,
  rules
}) => (
  <Controller
    control={control}
    name={registerTitle}
    rules={rules}
    render={({ field: { onChange } }) => (
      <InputWrapper inputLabel={label}>
        <ReactSelect
          options={options}
          value={{
            value: selectdValue,
            label: selectdValue
          }}
          inputId={registerTitle}
          onChange={(val: any) => onChange(val.value)}
          placeholder={placeholder}
          aria-labelledby={registerTitle}
          aria-label={`${registerTitle}-input`}
          styles={customSelectStyles}
          isDisabled={!options.length}
        />
      </InputWrapper>
    )}
  />
);

export default VerticalitySelect;
